import React, { useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Alert } from 'reactstrap';

function ValidateIPaddress(ipaddress) {
  if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
    return true;
  }
  return false;
}



function Launcher() {
  const pathParts = window.location.pathname.split('/')[2]?.split(':') || [];
  //console.log(pathParts);
  const serverIp = pathParts[0];
  const serverPort = pathParts[1];
  //console.log("serverIp", `${serverIp}`);


  const RedirectPage = (server) => {
    //console.log(`ServerIp: ${JSON.stringify(server)}` );
    //console.log(`ServerIp: ${server.serverIp}` );
    //console.log(`ServerPort: ${server.serverPort}` );
    useEffect(() => {
      window.location.replace(`steam://run/736590//+connect ${server.serverIp}:${server.serverPort}`);
    }, []);
    return null;
  };

  const links = [
    { label: 'OHDServers.net', url: 'https://ohdservers.net', color: '#4ade80' },
    { label: 'O:HD Website', url: 'https://operationharshdoorstop.com', color: '#60a5fa' },
    { label: 'Buy O:HD on Steam', url: 'https://store.steampowered.com/app/736590/Operation_Harsh_Doorstop/', color: '#f472b6' },
    { label: 'O:HD Discord', url: 'https://discord.com/invite/drakelings', color: '#818cf8' },
  ];

  if (ValidateIPaddress(serverIp)) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, rgba(30, 41, 59, 0.95), rgba(30, 41, 59, 0.98))',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card style={{
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '16px',
              }}>
                <CardBody className="text-center p-5">
                  <h1 style={{
                    color: '#fff',
                    fontSize: '2rem',
                    fontWeight: '700',
                    marginBottom: '0.5rem',
                    textShadow: '0 2px 10px rgba(0,0,0,0.3)',
                  }}>
                    Operation Harsh Doorstop
                  </h1>
                  <p style={{ color: '#94a3b8', marginBottom: '2rem' }}>
                    Connecting to server...
                  </p>

                  <Alert style={{
                    background: 'rgba(74, 222, 128, 0.1)',
                    border: '1px solid rgba(74, 222, 128, 0.3)',
                    borderRadius: '8px',
                    color: '#4ade80',
                  }}>
                    <strong>{serverIp}:{serverPort}</strong>
                  </Alert>

                  <div style={{ marginBottom: '2rem' }}>
                    {links.map((link) => (
                      <Button
                        key={link.url}
                        style={{
                          background: 'transparent',
                          border: `1px solid ${link.color}`,
                          color: link.color,
                          margin: '0.25rem',
                          padding: '0.5rem 1rem',
                          borderRadius: '8px',
                          transition: 'all 0.2s ease',
                        }}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onMouseOver={(e) => {
                          e.target.style.background = link.color;
                          e.target.style.color = '#1a1a2e';
                        }}
                        onMouseOut={(e) => {
                          e.target.style.background = 'transparent';
                          e.target.style.color = link.color;
                        }}
                      >
                        {link.label}
                      </Button>
                    ))}
                  </div>

                  <Button
                    style={{
                      background: '#4ade80',
                      border: 'none',
                      color: '#1a1a2e',
                      fontWeight: '600',
                      padding: '0.75rem 2rem',
                      borderRadius: '8px',
                    }}
                    onClick={() => window.history.back()}
                  >
                    ← Back
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <RedirectPage serverIp={serverIp} serverPort={serverPort} />
      </div>
    );
  }
  return null;
}




export default Launcher;
